import { palette } from "../../styles/theme";
export var SCALES_BY_ID = {
    1: 'security',
    2: 'status',
    3: 'social_relationships',
    4: 'competition',
    5: 'rationality',
    6: 'progress',
    7: 'feedback',
    8: 'innovation',
    9: 'altruism',
    10: 'financial_needs',
    11: 'autonomy'
};
export var Motivators = Object.keys(SCALES_BY_ID).reduce(function(prev, cur) {
    if (!SCALES_BY_ID[cur]) return prev;
    var m = {
        id: cur,
        name: SCALES_BY_ID[cur].replace('_', ' '),
        color: palette.brand.motivators.color[SCALES_BY_ID[cur]],
        backgroundColor: palette.brand.motivators.background[SCALES_BY_ID[cur]]
    };
    prev[m.id] = m;
    prev[m.name] = m;
    return prev;
}, {});

//# sourceMappingURL=Motivators.js.map